import { React, Styled } from '@common/3rd';
import { PageFooterComponents } from '@my-types';
import Widget from '../widget';

/**
 * Page footer
 */
class PageFooter<P, S, C extends PageFooterComponents> extends Widget<P, S, C> {
	protected initComponents(): C {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'page-footer'
			})`
				z-index: ${props => props.theme.PAGE_FOOTER_Z_INDEX};
			`
		} as C;
	}
	render() {
		const C = this.getComponents();
		return <C.Box >{this.props.children}</C.Box>;
	}
}

export default PageFooter;
